import React from 'react';
import { BlockTexto } from './BlockTexto';
import { Align, FontSize, widthPaper } from '../../../modules/ReceiptLayouts/Model';
import { isBoolean } from 'util';
export const BlockSeparator = ({ char, fontSize, bold, maxLeng, align }) => {
    if (!char || char === '-') {
        return (React.createElement("p", { style: {
                marginTop: '10px',
                width: '95%',
                height: '1px',
                background: 'black',
            } }, ''));
    }
    const max = maxLeng ? maxLeng : getMaxLength(fontSize);
    let texto = '';
    for (let i = 0; i < max; i++) {
        texto += char;
    }
    return React.createElement(BlockTexto, { texto: texto, align: align || defaultProps.align, fontSize: fontSize || defaultProps.fontSize, bold: isBoolean(bold) ? bold : defaultProps.bold });
};
const getMaxLength = (fontSize) => {
    const with80 = widthPaper === 80;
    switch (fontSize) {
        case FontSize.smaller:
            return with80 ? 38 : 38;
        case FontSize.small:
            return with80 ? 34 : 34;
        case FontSize.normal:
            return with80 ? 29 : 29;
        case FontSize.big:
            return with80 ? 25 : 25;
        case FontSize.bigger:
            return with80 ? 21 : 21;
        case FontSize.biggest:
            return with80 ? 19 : 19;
        case FontSize.extraBiggest:
            return with80 ? 15 : 15;
        default:
            return with80 ? 29 : 29; // a fontSize normal
    }
};
const defaultProps = {
    fontSize: FontSize.normal,
    bold: false,
    maxLeng: getMaxLength(FontSize.normal),
    align: Align.Center
};



//////////////////
// WEBPACK FOOTER
// ./src/components/Ticket/Blocks/BlockSeparator.tsx
// module id = 110
// module chunks = 0